export default "__VITE_ASSET__BEzwg7Hr__"